export default function buildUrl(url, baseUrl, searchParams) {
    var fetchUrl = typeof baseUrl === 'string' && baseUrl !== ''
        ? new URL(url, baseUrl).toString()
        : url;
    var searchParamsStr = new URLSearchParams(searchParams).toString();
    return "".concat(fetchUrl).concat(searchParamsStr !== undefined && searchParamsStr !== '' ? "?".concat(searchParamsStr) : '');
}
